import { ButtonTypeTokens, SelectiveListItemStateTokens, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import SharedPropsService from '../../../SharedPropsService';
import _ from 'lodash';
import { api } from '../../../configs/api';
import { getAppHeader } from '../../../configs/config';
import { nextStepCredStepper, updateCurrentStepId, } from '../../../configs/utils';
import AsyncStorage from "@react-native-async-storage/async-storage";
let selectedWidget = undefined;
let ifscCode = undefined;
let bankAccountNumber = undefined;
export const ToggleSelectAction = async (action, _datastore, { instrumentTrack, setDatastore }) => {
    ///unselected if any selected
    if (selectedWidget) {
        instrumentTrack('VERIFY_BANK_EXISTING_ACCOUNT_SELECTED');
        await setDatastore(action.routeId, selectedWidget, {
            state: SelectiveListItemStateTokens.NOT_SELECTED,
        });
        selectedWidget = undefined;
        ifscCode = undefined;
        bankAccountNumber = undefined;
    }
    else {
        await setDatastore(action.routeId, action.payload.targetWidgetId, { state: SelectiveListItemStateTokens.SELECTED });
        await setDatastore(action.routeId, 'continue', {
            type: ButtonTypeTokens.LargeFilled,
        });
        selectedWidget = action.payload.targetWidgetId;
        ifscCode = action.payload.bankIfscCode;
        bankAccountNumber = action.payload.bankAccountNumber;
    }
};
let hasNavigate = false;
export const BavVerifyAction = async (action, _datastore, { setDatastore, network, navigate, instrumentTrack, goBack, navigateToBase }) => {
    instrumentTrack('VERIFY_BANK_EXISTING_ACCOUNT_SELECTED');
    console.warn("SELECTED ITEM", action.payload.selectedItem);
    await setDatastore(action.routeId, 'continue', {
        loading: true,
    });
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : (await SharedPropsService.getUser())
        .linkedApplications[0].applicationId;
    const response = await network.post(api.bavVerify, {
        applicationId,
        bankAccountDetails: {
            // @ts-ignore
            bankAccountNumber: action.payload.selectedItem.accountNumber,
            // @ts-ignore
            bankIfscCode: action.payload.selectedItem.ifscCode,
        },
    }, { headers: await getAppHeader(), handleFromMF: true });
    if (_.get(response, 'status') !== 200) {
        // @ts-ignore
        const ifscNum = action?.payload?.selectedItem?.ifscCode;
        const errorMessage = response?.response?.data?.message;
        const errorCode = response?.response?.data?.voltErrorCode;
        if (errorCode === "KYC_VERIFICATION_FAILED_NAME_MISMATCH") {
            const failureJson = JSON.parse(response?.response?.data?.message);
            const heading = failureJson?.nameMatchFailureDetails?.description;
            const key1 = failureJson?.nameMatchFailureDetails?.source?.description;
            const value1 = failureJson?.nameMatchFailureDetails?.source?.value;
            const key2 = failureJson?.nameMatchFailureDetails?.target?.description;
            const value2 = failureJson?.nameMatchFailureDetails?.target?.value;
            await navigate(ROUTE.NAME_MISMATCH, {
                heading: heading,
                key1: key1,
                value1: value1,
                key2: key2,
                value2: value2,
                isFromKYC: false,
                ifscCode: ifscNum?.substring(0, 4)
            });
        }
        else if (typeof errorMessage === 'string') {
            setTimeout(() => {
                setDatastore(action.routeId, 'st', {
                    modalState: 'error',
                    errorSubtitle: errorMessage
                });
            }, 0);
        }
        else {
            const failureJson = JSON.parse(errorMessage);
            if (failureJson?.failureType === "NAME_MISMATCH") {
                const heading = failureJson?.nameMatchFailureDetails?.description;
                const key1 = failureJson?.nameMatchFailureDetails?.source?.description;
                const value1 = failureJson?.nameMatchFailureDetails?.source?.value;
                const key2 = failureJson?.nameMatchFailureDetails?.target?.description;
                const value2 = failureJson?.nameMatchFailureDetails?.target?.value;
                await navigate(ROUTE.NAME_MISMATCH, {
                    heading: heading,
                    key1: key1,
                    value1: value1,
                    key2: key2,
                    value2: value2,
                    isFromKYC: false,
                    ifscCode: ifscNum?.substring(0, 4)
                });
            }
        }
    }
    else {
        const currentStepId = _.get(response, 'data.updatedApplicationObj.currentStepId');
        if (currentStepId && currentStepId) {
            await updateCurrentStepId(currentStepId);
            const routeObj = await nextStepCredStepper();
            setTimeout(() => {
                setDatastore(action.routeId, 'st', {
                    modalState: 'success'
                });
            }, 0);
            setTimeout(() => {
                if (!hasNavigate) {
                    navigateToBase(routeObj.routeId, routeObj.params);
                }
            }, 5000);
        }
        await setDatastore(action.routeId, 'continue', {
            loading: false,
        });
    }
};
export const AddAccountNavAction = async (action, _datastore, { navigate, instrumentTrack }) => {
    instrumentTrack('VERIFY_BANK_ADD_ANOTHER_BANK_BUTTON_CLICKED');
    navigate(ROUTE.BANK_SELECT);
};
export const GoBackAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_STEPPER);
};
export const GoNext = async (action, _datastore, { navigateToBase, goBack }) => {
    hasNavigate = true;
    const routeObj = await nextStepCredStepper();
    await navigateToBase(routeObj.routeId, routeObj.params);
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
